import React, { useState } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';

export default function XDateRange({ minDate, maxDate, onChange = () => { } }) {
    const [range, setRange] = useState({
        start: minDate ? moment(minDate) : moment().subtract(7, 'days'),
        end: maxDate ? moment(maxDate) : moment()
    });

    const handleCallback = (start, end) => {
        setRange({ start, end });
        console.log("Selected range:", start.format('YYYY-MM-DD HH:mm:ss'), "to", end.format('YYYY-MM-DD HH:mm:ss'));
    };

    React.useEffect(() => {
        if (minDate && maxDate) {
            setRange({
                start: moment(minDate),
                end: moment(maxDate)
            });
        }
    }, [minDate, maxDate]);

    React.useEffect(() => {
        onChange(range.start.format('YYYY-MM-DD HH:mm:ss'), range.end.format('YYYY-MM-DD HH:mm:ss'));
    }, [range]);

    let inputStyle = {
        borderRadius: 4,
        border: '3px solid #eee',
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 8,
        paddingBottom: 8,
        fontSize: 12,
        background: '#ffff'
    };

    return (
        <div style={{ marginBottom: 10 }}>
            <DateRangePicker
                key={`${minDate || ''}-${maxDate || ''}`}
                initialSettings={{
                    timePicker: true,
                    startDate: range.start,
                    endDate: range.end,
                    minDate: minDate ? moment(minDate) : undefined,
                    maxDate: maxDate ? moment(maxDate) : undefined,
                    ranges: {
                        Today: [moment(), moment()],
                        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                        ...(minDate && maxDate ? { 'Camera Range': [moment(minDate), moment(maxDate)] } : {})
                    }
                }}
                onCallback={handleCallback}
            >
                <div>
                    <div style={{ fontSize: 13 }}> Select range</div>
                    <div style={inputStyle}>
                        {range.start.format('YYYY-MM-DD HH:mm:ss')} - {range.end.format('YYYY-MM-DD HH:mm:ss')}
                    </div>
                </div>
            </DateRangePicker>
        </div>
    );
}
